import {
	WeaTools
} from 'ecCom'

export const getHrmMobileSignInInfo = params => {
	return WeaTools.callApi('/api/hrm/kq/mobilesignin/getHrmMobileSignInInfo', 'POST', params);
}

//导出excel
export const exportExcel = (params = {}) => {
	return WeaTools.callApi('/api/ec/dev/table/export', 'POST', {
		dataKey: params
	})
}

export const getShowSignImg = (params = {}) => {
	return WeaTools.callApi('/api/hrm/kq/mobilesignin/getShowSignImg', 'GET', params)
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/apis/outside.js